import { cn } from '@/shared/lib/cn';
import { formatMoney } from '@/shared/lib/money';

export type Moneda = 'ARS' | 'MXN' | 'USD';

/**
 * Small money display cell used in Ventas tables and summary strips.
 * Keeps the currency suffix muted so the amount is the visual focus.
 */
export function MoneyCell({
  amount,
  moneda,
  emphasise,
}: {
  amount: number;
  moneda: Moneda;
  emphasise?: boolean;
}) {
  return (
    <span
      className={cn(
        'whitespace-nowrap',
        emphasise ? 'font-semibold text-foreground' : 'text-foreground',
      )}
    >
      {formatMoney(amount, moneda)}{' '}
      <span className="text-xs font-medium text-muted-foreground">{moneda}</span>
    </span>
  );
}
